import * as React from "react";

import { TemperatureUnitContext } from "../../../context/app-context";
import { convertToFahrenheit } from "../../../services/convertUnits";

type InfoSectionProps = {
    sectionTitle: string;
    isTemperature?: boolean;
    isSeaTemperature?: boolean;
    isNumberOfDays?: boolean;
    season?: "sun" | "cloudy" | "rainy";
    amount: number;
    smallMargins?: boolean;
    unit?: string;
    className?: string;
};
const iconMapping = {
    sun: "ico_sun_white.svg",
    cloudy: "ico_cloudy_white.svg",
    rainy: "ico_rainy_white.svg"
};

export const InfoSection = ({
    sectionTitle,
    isTemperature,
    isSeaTemperature,
    isNumberOfDays,
    amount,
    season,
    smallMargins,
    unit,
    className = ""
}: InfoSectionProps) => {
    const [unitFromContext] = React.useContext(TemperatureUnitContext);
    unit = unitFromContext || unit;
    season = season || "sun";
    let imageSrc = iconMapping[season];
    if (isSeaTemperature) imageSrc = "ico_sea_temperature_white.svg";
    if ((isTemperature || isSeaTemperature) && unit == "F") {
        amount = convertToFahrenheit(amount);
    }
    amount = Math.round(amount);

    let units = <span>{`°${unit}`}</span>;
    if (isNumberOfDays) {
        units = <span className="align-top text-[10px]">{`/month`}</span>;
    }

    return (
        <div className={className}>
            {sectionTitle && (
                <div
                    className={`text-[12px] ${
                        smallMargins ? "mb-[5px]" : "mb-[10px]"
                    } text-center font-bold font-bold tracking-wide opacity-60`}
                >
                    {sectionTitle}
                </div>
            )}
            <div className="flex items-center justify-center whitespace-nowrap">
                {!isNumberOfDays && (
                    <img
                        src={`/${imageSrc}`}
                        alt=""
                        className="h-[20px] w-[20px]"
                        loading="lazy"
                    />
                )}
                <span className="mb-[2px] ml-[12px] text-[18px]">
                    {amount} {units}
                </span>
            </div>
        </div>
    );
};
